<template>
  <footer>
    <a
      href="https://www.expert.de/Footer/Service/Kontaktformular"
      target="_blank"
      rel="noopener noreferrer"
      class="hidden btn-scroll-to-top cursor-pointer invisible lg:visible bg-white text-black border rounded-lg border-primary px-4 py-2 text-center z-40"
      style="bottom: 3.5rem"
    >
      <span class="flex items-center justify-center gap-2">
        <BasicIcon :name="'circle-info-light'" class="w-4 text-primary" />
        Hilfe
      </span>
    </a>
    <BasicScrollToTop />
    <div v-if="!$device.isLighthouse" class="text-sm">
      <div class="hidden lg:block bg-secondary-light solid border-t border-secondary">
        <div
          class="lg:container lg:mx-auto py-5 flex text-paragraph font-bold justify-between text-center"
        >
          <div class="text-left flex items-center gap-2">
            <BasicIcon class="w-4" :name="'address-card-regular'" />
            Experten-Beratung
          </div>
          <div class="flex items-center gap-2">
            <BasicIcon class="w-4" :name="'wrench-solid'" />
            Reparatur-Service
          </div>
          <div class="flex items-center gap-2">
            <BasicIcon class="w-4" :name="'gear-solid'" />
            Montage-Service
          </div>
          <div class="flex items-center gap-2">
            <BasicIcon class="w-3" :name="'euro-sign-solid'" />
            Finanzierungs-Service
          </div>
          <div class="flex items-center gap-2">
            <BasicIcon class="w-4" :name="'rotate-regular'" />
            Altgeräte-Entsorgung
          </div>
          <div class="text-right flex items-center gap-2">
            <BasicIcon class="w-4" :name="'truck-solid'" />
            Liefer-/Abholservice
          </div>
        </div>
      </div>
      <div class="bg-secondary p-4">
        <div class="lg:container lg:mx-auto lg:py-5">
          <div class="grid grid-cols-12 leading-6 gap-6 text-paragraph-light">
            <div class="hidden lg:flex flex-col gap-4" :class="basisPaybackFeature ? 'lg:col-span-6':'lg:col-span-7'">
              <div class="col-span-7 hidden lg:block font-bold leading-3 text-paragraph">expert Vorteile</div>
              <div class="gap-4 grid grid-cols-2">
                <ul>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Bei expert bezahlen Sie flexibel und sicher
                  </li>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Beste Beratung und Top-Services
                  </li>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Deutschlandweit über 400 Standorte
                  </li>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Bequeme Lieferung nach Hause
                  </li>
                </ul>
                <ul>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Direktabholung in Ihrem Fachmarkt
                  </li>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Verfügbarkeitsbenachrichtigung
                  </li>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    Aktionen & Gewinnspiele
                  </li>
                  <li class="flex items-center gap-2">
                    <BasicIcon class="w-4 text-primary" :name="'check-regular'" />
                    30 Tage Käuferschutz durch Trusted Shops
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-span-12 grid text-center gap-4" :class="basisPaybackFeature && currentStore.paybackStore ? 'lg:col-span-6 lg:grid-cols-2':'lg:col-span-5 lg:grid-cols-1'">
              <div class="flex flex-col gap-4 items-center">
                <div class="text-paragraph font-bold leading-3">expert Newsletter</div>
                <div class="leading-normal">
                  Bleib stets über die aktuellsten Angebote und Techniktrends informiert.
                </div>
                <div class="w-full flex justify-center">
                <a
                  class="btn-primary w-full text-center max-w-xs mb-3 block font-bold px-6"
                  :class="basisPaybackFeature && currentStore.paybackStore ? 'rounded-full':''"
                  @click="openNewsletterPopup()"
                >
                  Jetzt kostenlos registrieren
                </a>
                </div>
              </div>
              <template v-if="basisPaybackFeature && currentStore.paybackStore">
                <div class="flex flex-col gap-4 items-center">
                  <div class="text-paragraph font-bold leading-3">PAYBACK Newsletter</div>
                  <div class="leading-normal">
                    Du bist noch nicht dabei? Jetzt anmelden, um keine Coupons mehr zu verpassen!
                  </div>
                  <NuxtLink
                    class="btn-primary bg-payback w-full text-center max-w-xs mb-3 block font-bold rounded-full"
                    :to="'https://www.payback.de/info/mein-payback/einwilligungen/coupon-mail?excid=70_19305_601'"
                    :external="true"
                  >
                    Jetzt kostenlos registrieren
                  </NuxtLink>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$device.isMobile || $device.isTablet" class="col-span-12 py-5 px-4">
        <nav
          v-if="!$device.isLighthouse && navigationTree"
          class="flex flex-wrap justify-center"
          role="navigation"
          aria-label="Footer Navigation"
        >
          <template v-for="hardlink in cms_navigation" :key="hardlink.id">
            <template v-if="hardlink.descendants?.length > 0">
              <template v-for="link in hardlink.descendants" :key="link.id">
                <span class="first:hidden">|</span
                ><a
                  class="text-primary px-2"
                  :class="
                    link.name?.toLowerCase()?.indexOf('widerruf') > -1 ? 'font-bold' : ''
                  "
                  :href="link.url"
                  target="_self"
                  :title="link.name"
                  >{{ link.name }}</a
                >
              </template>
            </template>
          </template>
        </nav>
      </div>
      <div class="lg:container lg:mx-auto lg:py-5">
        <div
          class="lg:text-left flex flex-col justify-center items-center gap-10 lg:grid grid-cols-12 lg:pb-7 lg:gap-8 lg:items-start"
        >
          <template v-if="basisPaybackFeature && currentStore.paybackStore">
            <div class="col-span-2 lg:order-3 flex flex-col gap-4">
              <div class="text-center font-bold">Jetzt °punkten</div>
              <div class="lg:order-2">
                <div class="flex items-center justify-center gap-4 min-h-12">
                  <NuxtLink
                    v-for="entry in cashbaka.service"
                    :key="entry.image"
                    :title="entry.title"
                    :to="entry.href"
                  >
                    <nuxt-img
                      densities="x1"
                      loading="lazy"
                      class="h-8"
                      provider="cloudflare"
                      :src="entry.image"
                      :alt="entry.alt"
                    />
                  </NuxtLink>
                </div>
              </div>
            </div>
          </template>
          <div
            class="col-span-5 order-1 lg:order-3 border-t border-b lg:border-0 flex flex-col gap-4"
          >
            <div
              class="font-bold"
              :class="
                basisPaybackFeature && currentStore.paybackStore
                  ? 'text-center'
                  : 'text-left'
              "
            >
              Wir akzeptieren im Onlineshop folgende Zahlarten
            </div>
            <div
              class="grid grid-cols-3 lg:flex lg:justify-between items-center gap-4 gap-y-6 p-4 lg:p-0 min-h-12"
            >
              <div
                v-for="entry in paymentprovider.service"
                :key="entry.image"
                class="flex justify-center"
              >
                <nuxt-img
                  densities="x1"
                  loading="lazy"
                  provider="cloudflare"
                  class="min-h-5 max-h-10"
                  :class="entry.extra"
                  :src="entry.image"
                  :title="entry.title"
                  :alt="entry.alt"
                />
              </div>
            </div>
          </div>
          <div
            class="order-2 flex flex-col gap-4"
            :class="
              basisPaybackFeature && currentStore.paybackStore
                ? 'col-span-2'
                : 'col-span-3'
            "
          >
            <div
              class="font-bold"
              :class="
                basisPaybackFeature && currentStore.paybackStore
                  ? 'text-center'
                  : ''
              "
            >
              Sicher einkaufen bei expert
            </div>
            <div
              class="flex gap-4"
              :class="
                basisPaybackFeature && currentStore.paybackStore
                  ? 'justify-center'
                  : 'justify-start'
              "
            >
              <a
                v-for="entry in shoprating.service"
                :key="entry.image"
                :href="entry.href"
                :title="entry.title"
              >
                <nuxt-img
                  densities="x1"
                  loading="lazy"
                  class="h-11"
                  provider="cloudflare"
                  :src="entry.image"
                  :alt="entry.alt"
                />
              </a>
            </div>
          </div>
          <div
            class="order-3 lg:order-1 flex flex-col gap-4"
            :class="
              basisPaybackFeature && currentStore.paybackStore
                ? 'col-span-3'
                : 'col-span-4'
            "
          >
            <div
              class="font-bold"
              :class="
                basisPaybackFeature && currentStore.paybackStore
                  ? 'text-center'
                  : ''
              "
            >
              Folgen Sie uns
            </div>
            <div
              class="flex justify-between lg:justify-start items-center gap-4 p-4 lg:p-0"
            >
              <a
                v-for="entry in social_navigation"
                :key="entry.id"
                :href="entry.url"
                target="_blank"
                :title="entry.name"
              >
                <img
                  loading="lazy"
                  :src="entry.imgSrc"
                  :alt="entry.alt"
                  class="min-h-[20px] max-h-10"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <template v-if="$device.isDesktop">
        <div class="container mx-auto pb-9">
          <LayoutFooterNavigation
            v-if="!$device.isLighthouse"
            :tree="navigationTree"
            :limit="10"
            :basedir="baseDir"
            :external="false"
            :moretitle="'mehr'"
            :morenavitemclass="'more'"
            :class="'grid grid-cols-6 gap-8'"
          />
        </div>
      </template>
    </div>
    <ClientOnly>
      <div v-if="$device.isDesktop" class="lg:bg-secondary footer-nav">
        <div v-if="!$device.isLighthouse" class="container mx-auto py-4 lg:py-5">
          <nav
            v-if="cms_navigation"
            class="cms-nav grid grid-cols-6 gap-8"
            role="navigation"
            aria-label="Footer Navigation"
          >
            <ul
              v-for="hardlink in cms_navigation.sort((a, b) => a.position - b.position)"
              :key="hardlink.id"
            >
              <li class="nav-item" v-text="hardlink.name" />
              <template v-if="hardlink.descendants?.length > 0">
                <li
                  v-for="link in hardlink.descendants.sort(
                    (a, b) => a.position - b.position
                  )"
                  :key="link.id"
                  class="nav-item"
                >
                  <a
                    v-if="link.url?.startsWith('javascript:')"
                    class="nav-link"
                    :href="link.url"
                    :title="link.title"
                    >{{ link.name }}</a
                  >
                  <NuxtLink
                    v-else
                    class="nav-link"
                    :class="
                      link.name?.toLowerCase()?.indexOf('widerruf') > -1
                        ? 'font-bold'
                        : ''
                    "
                    :to="link?.url"
                    :external="true"
                    :title="link.title"
                    >{{ link.name }}</NuxtLink
                  >
                </li>
              </template>
            </ul>
          </nav>
        </div>
      </div>
    </ClientOnly>
    <div v-if="!$device.isLighthouse" class="text-sm bg-secondary-light p-4">
      <div class="lg:container mx-auto py-4 lg:py-5">
        <div
          class="foot-wrapper flex-col-reverse lg:flex-row lg:gap-[30px] gap-[10px] items-center lg:items-start"
        >
          <div class="text-center lg:text-left">
            <p>
              Alle Preise in Euro und inkl. der gesetzlichen Mehrwertsteuer. ggf. zzgl.
              Versandkosten. <br />
              Lieferung innerhalb Deutschlands.
              <br /><br />
              Änderungen und Irrtümer vorbehalten. Abbildungen ähnlich. Nur solange der
              Vorrat reicht.
            </p>
            <br />
            <BasicLegalGuaranteeLink />
            <br />
            <p><strong>© expert e-Commerce GmbH</strong></p>
          </div>
          <div class="recall-button p-5">
            <NuxtLink
              to="/shop/mein-expert/retoure-suchen"
              class="btn-primary w-full text-center max-w-xs block font-bold px-6 py-4"
            >
              Vertrag widerrufen
            </NuxtLink>
          </div>
        </div>
        <p>&nbsp;</p>
        <a
          href="/shop/unsere-produkte/tv-audio?campaignID="
          aria-label="weiter zur expert.de"
          class="inline-block w-40 h-6"
        >
          <svg
            id="link-to-central"
            aria-label="weiter zur expert.de"
            title="weiter zur expert.de"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <rect
              class="w-full h-full inline-block bg-transparent"
              x="10"
              y="10"
              fill-opacity="0"
            />
          </svg>
        </a>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
import { inject } from "vue";
import { getExpNavigationTree } from "~/composables/ExpApi/expCache";
import { ProvideNames } from '#shared/statics';
import { usePopupQueue } from "~/composables/states";
defineProps({
  baseDir: {
    type: String,
    default: () => {
      return inject(ProvideNames.BASE_DIR);
    },
  },
});
const currentStore = useCurrentStore();
const { enqueue } = usePopupQueue();
const { isLighthouse } = useDevice();
const { data: navigationTree } = isLighthouse ? [] : getExpNavigationTree("FOOTER");
const { data: cms_navigation } = isLighthouse
  ? []
  : getExpNavigationTree("FOOTER_HARDLINKS");
const { data: social_navigation } = isLighthouse
  ? []
  : getExpNavigationTree("FOOTER_SOCIAL");

const paymentprovider = {
  service: [
    {
      image: "93/ff/b7/2a5b1c4b11b306d8aef7c59403dd8ff4b6/Wero_Logo_Badge_RGB.svg",
      alt: "Wero",
      title: "Wero",
      extra: "condition-wero",
    },
    {
      image: "/59/b1/e7/d5c2ef10b639c5fa5c7135def83b8ffd2d/paypal.png",
      alt: "PayPal",
      title: "PayPal",
    },
    {
      image: "/59/66/c1/5f9097f6f0a1870b1bc1aa65adbab43b50/AmericanExpress-New.png",
      alt: "AmericanExpress",
      title: "AmericanExpress",
    },
    {
      image: "/52/b5/f9/f9b6cfdc549077bf4ceaa072a07fe542fa/Visa.png",
      alt: "Visa",
      title: "Visa",
    },
    {
      image: "/6f/c6/7d/ceb8c0229fab5cb8a7f84b8015bc7260de/mastercard.png",
      alt: "mastercard",
      title: "mastercard",
    },
    {
      image: "/63/8d/a9/844f4b4d26f4c76fd92f68e6b8daac93c0/Klarna.png",
      alt: "Klarna",
      title: "Klarna",
    },
    {
      image: "/68/1a/97/f3eeb92221b695fb99a95694480b268159/Billie-logo.png",
      alt: "Billie",
      title: "Billie",
    },
  ],
};

const cashbaka = {
  service: [
    {
      image: "/97/27/77/05262c90ceebe43a34e6fdec70f562de6a/Payback-logo.svg",
      alt: "PAYBACK",
      title: "PAYBACK",
      href: "/shop/payback",
    },
  ],
};

const shoprating = {
  service: [
    {
      image: "/static/images/test/trustedShop.jpg",
      href:
        "https://www.trustedshops.de/bewertung/info_X6C1E9EE9E034D3276D30CB55A1778205.html",
      alt: "trusted shop",
      title: "trusted shops",
    },
    {
      image: "/98/43/45/4873302d7ac7b399e54afc07be2bd60d8f/s1_idealo-partner_90-0.png",
      href: "https://www.idealo.de/preisvergleich/Shop/286835.html",
      alt: "unsere Bewertungen bei idealo.de",
      title: "unsere Bewertungen bei idealo.de",
    },
  ],
};

function openNewsletterPopup() {
  enqueue({
    id: "NL-SignUp",
  });
}

const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const basisPaybackFeature = computed(
  () =>
    featureStatePayback.value
    && (useFeatureValue('exsi-1556').value?.name == 'basic'
      || useFeatureValue('exsi-1556').value?.name == 'redemption'
      || useFeatureValue('exsi-1556').value?.name == 'full')
);

</script>
<style lang="postcss" scoped>
.condition-wero {
  @apply min-w-12;
}

.foot-wrapper {
  display: flex;
  justify-content: space-between;
}

.cms-nav {
    & .nav-item {
        &:hover {
            @apply text-primary;
        }
    }
}
</style>
